<script lang="ts">
  import { categories } from '../../store'
  import WikiCategory from './components/WikiCategory.svelte'
</script>

{#if $categories.length}
  <div class="wiki-categories">
    {#each $categories as category (category.pk)}
      <WikiCategory {category} />
    {/each}
  </div>
{/if}

<style lang="scss">
  .wiki-categories {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 31px;

    @media (min-width: 320px) and (max-width: 1000px) {
      display: grid;
      grid-gap: 30px;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 10px;
    }

    @media (max-width: 500px) {
      grid-template-columns: 1fr;
    }
  }
</style>